import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "errors"];

  connect() {
    this.validateOnInput();
  }

  validateOnInput() {
    this.inputTarget.addEventListener("input", () => {
      this.validate();
    });
  }

  validate() {
    const value = this.cleanDomain(this.inputTarget.value);
    const errorMessage = this.getErrorMessage(value);
    this.showError(errorMessage);
    return !errorMessage;
  }

  getErrorMessage(value) {
    if (!value) {
      return "Domain is required";
    }

    if (value.length > 253) {
      return "Domain must be 253 characters or less";
    }

    const domainRegex = /^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,}$/i;
    if (!domainRegex.test(value)) {
      return "Must be a valid domain name format";
    }

    const dotCount = (value.match(/\./g) || []).length;
    if (dotCount < 2) {
      return "Must be a subdomain (e.g., premium.mypodcast.com), not a root domain";
    }

    return null;
  }

  showError(message) {
    if (message) {
      this.errorsTarget.textContent = message;
      this.errorsTarget.classList.remove("hidden");
    } else {
      this.errorsTarget.textContent = "";
      this.errorsTarget.classList.add("hidden");
    }
  }

  cleanDomain(value) {
    let cleaned = value.trim();

    // Remove prefixes
    cleaned = cleaned.replace(/^https?:\/\//i, "");
    cleaned = cleaned.replace(/^ftp:\/\//i, "");
    cleaned = cleaned.replace(/^www\./i, "");

    // Remove any path components (everything after /)
    cleaned = cleaned.split("/")[0];

    return cleaned;
  }

  submit(event) {
    const cleanedValue = this.cleanDomain(this.inputTarget.value);
    this.inputTarget.value = cleanedValue;

    const isValid = this.validate();
    
    if (!isValid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.inputTarget.focus();
    }
  }
}
